export default "__VITE_ASSET__Bb9sydVK__"